<template>
  <v-flex xs12 sm6><span>Raised Light Theme</span>
    <v-card height="185px" flat color="white">
      <v-card-text>
        <div v-for="item in customers">
          <v-btn color="primary" @click="customer(item._id)">{{item.name}}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Customer',
  data () {
    return {
      error: null,
      customers: []
    }
  },
  mounted () {
    // this.customer()
    this.loadingCustomers()
  },
  methods: {
    ...mapActions(['setCustomer']),
    loadingCustomers () {
      this.$http.get(process.env.URL + '/customers', {
        params: {
          customer: this.customer
        }
      }).then((results) => {
        this.customers = results.data.result
        console.log(results.data.result)
      }).catch((err) => {
        console.log(err)
      })
    },
    customer (customer) {
      window.location = '/login?customer=' + customer
      // // window.location = '/login/' + customer
      this.setCustomer(customer)
      localStorage.setItem('riscSchedulePatientCustomer', customer)
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customer/Customer.vue